const except = [
    'dt',
    'infocompte',
    'persist'
];


/**
 * Dispatch les paramètres dans les urls
 * @param item  Item sur lequel ajouter l'event listener
 * @param mode  si on est dans un mode spécial
 */
function dispatchFollowParam (item, mode = null) {

    item.addEventListener('mousedown', (e) => {

        const url         = new URL(window.location.href) // URL de la page web en cours
        //const HTMLElement = document.querySelector('a') // Element HTML pour lequel on va changer l'url
        const itemUrl = new URL(item.href) // Url du tag HTML sur lequel on se trouve

        // Fusion des paramètres
        const searchParams = new URLSearchParams({
            ...Object.fromEntries(itemUrl.searchParams),
            ...Object.fromEntries(url.searchParams)
        })

        // Retirer de searchParams les paramètre contenu dans le tableau except
        except.forEach((v) => {
            searchParams.delete(v)
        })

        // Injecte les paramètres contenu dans l'url de la page
        // dans l'url contenu dans l'élément HTML
        searchParams.forEach((v, k) => {

            // Si l'url d'origine est doc.pcsoft.et et que v est vide
            // On change la valeur de v par pcsnullparam
            if(itemUrl.host === "doc.pcsoft.fr" && v === "") {
                v = "pcsnullparam";
            }

            itemUrl.searchParams.set(k, v)
        })

        // Gestion du COOKIEPANIER si on est en mode shop
        if(mode === 'shop' && Cookies.get('COOKIEPANIER')) {
            itemUrl.searchParams.set('shop', Cookies.get('COOKIEPANIER'))
        }

        // Injecte le hash contenu dans l'url de la page
        // dans l'url contenu dans l'élément HTML
        /*if(!itemUrl.hash) {
            itemUrl.hash = url.hash
        }*/

        // Réinjecte l'url dans l'élément HTML
        // Remplace la valeur =pcsnullparam dans le cas ou le paramètre est vide
        item.href = itemUrl.toString().replaceAll('=pcsnullparam', '')
    });
}

/**
 * Initialise le suivi des paramètres dans les liens
 */
export function initFollowParam () {

    /**
     * Gestion des urls ayant une classe FollowParam.
     * On fait suivre les paramètres dans les autres urls pendant la navigation sur le site
     * @type {NodeListOf<Element>}
     */
    const followParam = document.querySelectorAll('.FollowParam')
    if(followParam) {
        followParam.forEach(item => dispatchFollowParam(item))
    }

    /**
     * Gestion des urls ayant une classe FollowParamShop.
     * On fait suivre les paramètre dans les autres urls, puis on ajout le contenu du cookie CookierPanier.
     */
    const followParamShop = document.querySelectorAll('.FollowParamShop');
    if(followParamShop) {
        followParamShop.forEach(item => dispatchFollowParam(item, 'shop'));
    }
}

initFollowParam();
